import type { FaireProductEntity } from "../../entity_types/product";

export const p_vfj8xt2ffb: FaireProductEntity = {
  token: "p_vfj8xt2ffb",
  type: "product",
  name: "Masc Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/bc6b4945674a311f313d8d2cf6025d01107606e57120522beed945098a907854.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/04d58791cfb9bd427e02188678461a0e47688232a72d8cbcea472853aa2fccc5.jpeg",
    "https://cdn.faire.com/fastly/be0c31d1997482de2adfa8fd50920fc30b28c9e1eb9841e39f156fea9b5d3c6e.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/0b4535dbfc9949fd7a4974eab057866efcd59f1e09a64e4d20a48a294a33c26e.jpeg",
    "https://cdn.faire.com/fastly/115ba7b9586567a841ae0b3a75ded512184ecf743d536db4fe1b864e21acf616.jpeg"
  ],
  priceDollars: 6.75,
  description: "Soft edges, strong stance—these socks know masculinity is a spectrum and they look good on it.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:23.245Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
